<script>
import RestaurantCard from '@/components/organism/restaurants/RestaurantCard'
import RestaurantsHeading from '@/components/organism/restaurants/RestaurantsHeading'
import isEmpty from 'lodash.isempty'

export default {
    name: 'List',
    components: { RestaurantsHeading, RestaurantCard },
    props: {
        restaurants: {
            type: Object,
            default: () => {},
        },
        setList: Function,
        brand: Boolean,
    },
    computed: {
        hasAddress() {
            return !isEmpty(this.$store.getters['order/address'])
        },
    },
    methods: {
        getPage(page) {
            this.setList(this.restaurants, this.$route, { page: page }, { pageLoader: false })
        },
    },
}
</script>

<template lang="pug">
.list
    restaurants-heading(:restaurants="restaurants" :brand="brand")
    .row.card-gutter(v-if="restaurants.length" v-observer="getPage")
        template(v-for="(restaurant, index) in restaurants")
            restaurant-card.mb-3(
                :brand="brand"
                :reduce="brand && index > 0 && hasAddress"
                :data-page="index && [0 , restaurants.itemsPerPage-1].includes(index%restaurants.itemsPerPage) && !restaurant  ? Math.floor((index/restaurants.itemsPerPage))+1 : undefined"
                :key="`restaurant-${index}`"
                :delay="restaurants.delay"
                :model="restaurant")
            .w-100.my-4(v-if="brand && index === 0 && hasAddress" key="brandResturantCardSeparator")
</template>
